import { render, staticRenderFns } from "./mDetail.vue?vue&type=template&id=4da8e510&scoped=true&"
import script from "./mDetail.vue?vue&type=script&lang=js&"
export * from "./mDetail.vue?vue&type=script&lang=js&"
import style0 from "./mDetail.vue?vue&type=style&index=0&id=4da8e510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8e510",
  null
  
)

export default component.exports